import {GLOBAL_CONSTANTS} from "../constants/global-constants";
import 'moment/locale/tr'  // without this line it didn't work
import 'moment/locale/en-au'  // without this line it didn't work

import UsdSvg from "../assets/parities/usd.svg";
import BtcSvg from "../assets/parities/btc.svg";
import AdaSvg from "../assets/parities/ada.svg";
import BnbSvg from "../assets/parities/bnb.svg";
import DogSvg from "../assets/parities/dog.svg";
import EthSvg from "../assets/parities/eth.svg";
import LnkSvg from "../assets/parities/lnk.svg";
import LtcSvg from "../assets/parities/ltc.svg";
import SbhUsd from "../assets/parities/shb.svg";
import SolSvg from "../assets/parities/sol.svg";
import TrxSvg from "../assets/parities/trx.svg";
import XrpSvg from "../assets/parities/xrp.svg";
import EtcSvg from "../assets/parities/etc.svg";
import AvaSvg from "../assets/parities/ava.svg";
import Usdt from "../assets/parities/usdt.svg";
import i18n from "../i18n/i18n";
import UsdcSvg from "../assets/parities/usdc.svg";
import BrlSvg from "../assets/parities/brl.svg";
import CadSvg from "../assets/parities/cad.svg";
import TrySvg from "../assets/parities/try.svg";
import RubSvg from "../assets/parities/rub.svg";
import EurSvg from "../assets/parities/eur.svg";
import ClpSvg from "../assets/parities/clp.svg";
import CnySvg from "../assets/parities/cny.svg";
import DkkSvg from "../assets/parities/dkk.svg";
import VndSvg from "../assets/parities/vnd.svg";
import PlnSvg from "../assets/parities/pln.svg";
import IdrSvg from "../assets/parities/idr.svg";
import JpySvg from "../assets/parities/jpy.svg";
import KrwSvg from "../assets/parities/krw.svg";
import InrSvg from "../assets/parities/inr.svg";
import PhpSvg from "../assets/parities/php.svg";
import MxnSvg from "../assets/parities/mxn.svg";
import moment from "moment";
import AznSvg from "../assets/parities/azn.svg";

const GlobalStates = {
    modalType: null,
    modalTab: null,
    modalCurrency: null,
    theme: '',
    gameSelectedCurrency: localStorage.getItem('gameSelectedCurrency') || null,
    defaultSearchGames: [],
    gameProviders: [],
    networks: [],
    iconList: {
        "USDT": {
            icon: <Usdt/>,
        },
        "BRL": {
            icon: <BrlSvg/>,
        },
        "CAD": {
            icon: <CadSvg/>,
        },
        "TRY": {
            icon: <TrySvg/>,
        },
        "AZN": {
            icon: <AznSvg/>,
        },
        "RUB": {
            icon: <RubSvg/>
        },
        "EUR": {
            icon: <EurSvg/>
        },

        "CLP": {
            icon: <ClpSvg/>
        },

        "CNY": {
            icon: <CnySvg/>
        },


        "DKK": {
            icon: <DkkSvg/>
        },


        "VND": {
            icon: <VndSvg/>
        },

        "PLN": {
            icon: <PlnSvg/>
        },


        "IDR": {
            icon: <IdrSvg/>
        },

        "JPY": {
            icon: <JpySvg/>
        },


        "KRW": {
            icon: <KrwSvg/>
        },

        "INR": {
            icon: <InrSvg/>
        },

        "PHP": {
            icon: <PhpSvg/>
        },

        "MXN": {
            icon: <MxnSvg/>
        },

        "USDC": {
            icon: <UsdcSvg/>,
        },
        "USD": {
            icon: <UsdSvg/>,
        },


        "BTC": {
            icon: <BtcSvg/>,
        },

        'ADA': {
            icon: <AdaSvg/>,
        },
        'BNB': {
            icon: <BnbSvg/>,
        },

        'DOGE': {
            icon: <DogSvg/>,
        },
        'ETH': {
            icon: <EthSvg/>,
        },
        'LINK': {
            icon: <LnkSvg/>,
        },
        'LTC': {
            icon: <LtcSvg/>,
        },
        'SHIB': {
            icon: <SbhUsd/>,
        },
        'SOL': {
            icon: <SolSvg/>,
        },
        'TRX': {
            icon: <TrxSvg/>,
        },
        'XRP': {
            icon: <XrpSvg/>,
        },


        'ETC': {
            icon: <EtcSvg/>
        },
        'AVAX': {
            icon: <AvaSvg/>
        },
    },
    inPlay: false,
    notifications: [],
    configuration: {},
    languages: [],
    activeLanguage: {},
    agent: {},
    sidebarShown: false,
    headerSearchShow: false,
    isGameFullScreen: false,
    chatShown: false,
    symbols: {
        "EUR": "€",
        "USD": "$",
        "BRL": "R$",
        "CAD": "CA$",
        "CLP": "CL$",
        "CNY": "¥",
        "DKK": "kr",
        "IDR": "Rp",
        "INR": "₹",
        "JPY": "¥",
        "KRW": "₩",
        "MXN": "M$",
        "PHP": "₱",
        "PLN": "zł",
        "RUB": "руб",
        "TRY": "₺",
        "VND": "₫"
    }


};

let cdnKey = ''

function loadTranslations(lng) {
    if (!cdnKey || typeof cdnKey !== 'string') {
        console.error('CDN key is missing or invalid. Unable to load translations.');
        return Promise.resolve('CDN key is missing or invalid');
    }

    // Validate lng
    if (!lng || typeof lng !== 'string') {
        console.error('Language (lng) is missing or invalid. Unable to load translations.');
        return Promise.resolve('Language (lng) is missing or invalid');
    }


    return fetch(`https://cdn.ebetlab.com/ebetlab/${cdnKey}/languages/${lng}.json?v=${moment().format('DD-MM:HH:mm')}`)
        .then((response) => response.json())
        .then((data) => {
            i18n.addResourceBundle(lng, 'translation', data, true, true);
        })
        .catch((error) => {
            // Handle any errors
            console.error('Error loading translations:', error.message);
        });
}

const globalReducer = (state = GlobalStates, action) => {
    switch (action.type) {

        case GLOBAL_CONSTANTS.SET_GAME_FULLSCREEN:
            return {
                ...state,
                isGameFullScreen: action.data
            }
        case GLOBAL_CONSTANTS.SET_SIDEBAR_SHOW:
            return {
                ...state,
                sidebarShown: action.data,
                chatShown: action.data ? false : state.chatShown,
                headerSearchShow: action.data ? false : state.headerSearchShow
            }


        case GLOBAL_CONSTANTS.SET_CHAT_SHOWN:
            return {
                ...state,
                chatShown: action.data,
                sidebarShown: action.data ? false : state.sidebarShown,
                headerSearchShow: action.data ? false : state.headerSearchShow
            }

        case GLOBAL_CONSTANTS.SET_DEFAULT_SEARCH_GAMES:
            return {
                ...state,
                defaultSearchGames: action?.data
            }

        case GLOBAL_CONSTANTS.SET_HEADER_SEARCH_SHOWN:
            return {
                ...state,
                headerSearchShow: action.data,
                chatShown: action.data === true ? false : state.chatShown,
                sidebarShown: action.data === true ? false : state.sidebarShown
            }
        case GLOBAL_CONSTANTS.SET_USER_AGENT:
            return {
                ...state,
                agent: action.data
            }

        case GLOBAL_CONSTANTS.SET_CONFIGURATION:
            cdnKey = action?.data?.cdn
            return {
                ...state,
                configuration: action.data,
                languages: action.data?.languages || [],
                activeLanguage: action?.data?.languages?.length >= 1 ? action?.data?.languages[0] : {}
            }

        case GLOBAL_CONSTANTS.SET_ACTIVE_LANGUAGE:
            let lang = state.languages.find(i => i.key === action.data)

            if (!lang)
                lang = state.languages.find(i => i.key === 'en')

            loadTranslations(lang?.key).then(() => {
                localStorage.setItem('language', lang?.key)
                i18n.changeLanguage(lang?.key).then(null)

                moment.locale(lang?.key === 'tr' ? 'tr' : 'en-au')
            });

            document.documentElement.lang = lang?.key
            return {
                ...state,
                activeLanguage: lang
            }

        case GLOBAL_CONSTANTS.SET_MODAL_TAB:
            return {
                ...state,
                modalTab: action.data
            }

        case GLOBAL_CONSTANTS.SET_NOTIFICATIONS:
            return {
                ...state,
                notifications: action.data
            }

        case GLOBAL_CONSTANTS.APPEND_NOTIFICATIONS:
            return {
                ...state,
                notifications: [action.data, ...state.notifications]
            }

        case GLOBAL_CONSTANTS.SET_MODAL_CURRENCY:
            return {
                ...state,
                modalCurrency: action.data
            }
        case GLOBAL_CONSTANTS.SET_IN_PLAY:
            return {
                ...state,
                inPlay: action.data
            }
        case GLOBAL_CONSTANTS.SET_MODAL_TYPE:
            return {
                ...state,
                modalType: action.data
            }

        case GLOBAL_CONSTANTS.SET_GAME_PROVIDERS:
            return {
                ...state,
                gameProviders: action.data
            }
        case GLOBAL_CONSTANTS.SET_SELECTED_CURRENCY:
            localStorage.setItem('gameSelectedCurrency', action.data)
            return {
                ...state,
                gameSelectedCurrency: action.data
            }

        case GLOBAL_CONSTANTS.SET_THEME:
            localStorage.setItem('theme', action.data)

            return {
                ...state,
                // theme: state.theme === 'dark' ? 'light' : 'dark'
                theme: action.data
            }
        case GLOBAL_CONSTANTS.SET_NETWORKS:

            return {
                ...state,
                networks: action.data
            }

        default:
            return state;

    }
};

export default globalReducer;
